//
//
//
//
//
//
//
//
//
//

export default {
  created(){
    this.$Loading.config({
      color: '#00fbfd',
      height:2
    });
  }
}



// WEBPACK FOOTER //
// ./src/App.vue